// extracted by mini-css-extract-plugin
export default {"TabsContainer":"Tabs_TabsContainer__gBY+-","TabsScroller":"Tabs_TabsScroller__f08hQ","TabsIndicator":"Tabs_TabsIndicator__TXep2"};